import React from 'react';
import { HiOutlineExclamation, HiOutlineCheckCircle, HiOutlineXCircle } from 'react-icons/hi';
import './RulesModal.scss'; 

interface PlanInfoForModal {
  name: string;
  price: number;
  period: string;
}

interface RulesModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  planDetails: PlanInfoForModal | null;
  theme: string; 
}

const RulesModal: React.FC<RulesModalProps> = ({ isOpen, onClose, onConfirm, planDetails, theme }) => {
  if (!isOpen || !planDetails) return null; 

  return (
    <div className={`rules-modal-overlay ${theme}`}> 
      <div className="rules-modal-content">
        <div className="rules-modal-header">
          <HiOutlineExclamation className="header-icon" />
          <h2>قوانین و مقررات خرید پلن</h2>
        </div>
        <div className="rules-modal-body">
          <p>
            شما در حال انتخاب <strong>{planDetails.name}</strong> برای دوره{' '}
            <strong>{planDetails.period}</strong> با هزینه{' '}
            <strong>${planDetails.price.toLocaleString('en-US')}</strong> هستید.
          </p>
          <ul className="rules-list">
            <li>این سرویس برای مدیریت ریسک و بهبود نظم معاملاتی شما طراحی شده است و تضمینی برای سودآوری معاملات شما ارائه نمی‌دهد.</li>
            <li>مسئولیت تمامی معاملات و تصمیم‌گیری‌های نهایی بر عهده کاربر می‌باشد.</li>
            <li>پلن خریداری شده غیرقابل انتقال به غیر و غیرقابل استرداد می‌باشد (مگر در موارد خاص طبق قوانین سایت).</li>
            <li>استفاده از سرویس به منزله پذیرش تمامی <a href="/terms-of-service" target="_blank" rel="noopener noreferrer">شرایط خدمات</a> وبسایت است.</li>
            <li>هرگونه سوءاستفاده یا تلاش برای اختلال در عملکرد سیستم منجر به مسدودسازی حساب کاربری خواهد شد.</li>
            <li>اطلاعات حساب و معاملات شما به صورت محرمانه نگهداری خواهد شد.</li>
          </ul>
          <p className="confirmation-text">
            با کلیک بر روی دکمه "تایید و ادامه"، شما موافقت خود را با تمامی قوانین و شرایط فوق اعلام می‌دارید.
          </p>
        </div>
        <div className="rules-modal-footer">
          <button className="modal-btn cancel-btn" onClick={onClose}>
            <HiOutlineXCircle /> انصراف
          </button>
          <button className="modal-btn confirm-btn" onClick={onConfirm}>
            <HiOutlineCheckCircle /> تایید و ادامه
          </button>
        </div>
      </div>
    </div>
  );
};

export default RulesModal;